export default __webpack_public_path__ + "bae95eb2f889c797e43509dbc8f9b439.woff";